<template>
  <div class="pb-5 mx-auto">
    <div class="lg:flex lg:items-center lg:justify-between lg:h-10">
      <div class="flex items-center flex-1 min-w-0">
        <button v-if="backStep" @click="$router.back()" class="inline-flex items-center justify-center w-8 h-8 mr-2 text-lg leading-none text-gray-500 transition duration-150 bg-transparent rounded hover:bg-gray-100 hover:no-underline">
          &larr;
        </button>
        <router-link v-else-if="backRoute" :to="backRoute" class="inline-flex items-center justify-center w-8 h-8 mr-2 text-lg leading-none text-gray-500 transition duration-150 bg-transparent rounded hover:bg-gray-100 hover:no-underline">
          &larr;
        </router-link>
        <fa v-if="icon" :icon="['far', icon]" class="mr-2 text-2xl opacity-75" /> 
        <div>
          <h1 v-if="title" class="text-lg font-bold leading-tight text-gray-900 sm:text-xl sm:truncate">
            {{ title }}
          </h1>
          <div v-if="!!$slots.subtitle">
            <slot name="subtitle" />
          </div>
          <div v-else-if="subtitle" v-html="subtitle" class="font-medium leading-tight text-gray-500">
          </div>
        </div>
      </div>
      <div class="flex mt-4 lg:mt-0 lg:ml-4">
        <slot />
      </div>
    </div>
    <slot name="subheader" />
  </div>
</template>

<script>
export default {
  name: 'PageHeader',

  props: {
    title: {
      type: String
    },

    subtitle: {
      type: String
    },

    icon: {
      type: String
    },

    backStep: {
      type: Boolean
    },

    backRoute: {
      type: Object
    }
  }
}
</script>